module.exports = __webpack_public_path__ + "static/media/logo-maker-white.ab1bc29b.svg";